import { h } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import CheckmarkIcon from 'utils/icon/icon-checkmark.svg';
import { withCartContext } from './cart-context';
import CartGwpProducts from './cart-gwp-products';

const CartGwpThreshold = ({ gwp, cart }) => {
  const config = useMemo(() => {
    const minimumAmount = parseFloat(gwp.minimumPurchaseAmount);
    const cartTotal = cart.state.items?.reduce((acc, item) => {
      if (!item.properties._gwp) {
        return acc + item.line_price;
      }
      return acc;
    }, 0);
    let isEligible = minimumAmount <= cartTotal / 100;
    let percentage = cartTotal / minimumAmount;

    if (gwp.minimums === 'minimum-qty') {
      const cartTotalCount = cart.state.items?.reduce((acc, item) => {
        if (!item.properties._gwp) {
          return acc + item.quantity;
        }
        return acc;
      }, 0);
      const minimumQty = parseInt(gwp.minimumQuantity, 10);
      isEligible = cartTotalCount >= minimumQty;
      percentage = (cartTotalCount / minimumQty) * 100;
    }

    let message = isEligible ? gwp.eligibleTitle : gwp.preEligibilityTitle;
    let isAdded = false;
    const addedItems = cart.state.items?.filter((item) => item.properties._gwp === gwp.id);
    if (addedItems?.length === parseInt(gwp.giftQuantity, 10)) {
      message = gwp.eligibleSubtext;
      isAdded = true;
    }
    return { message, percentage, isEligible, isAdded, addedItems };
  }, [cart, gwp]);

  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (config.addedItems.length && !config.isEligible) {
      cart.remove(config.addedItems.map((item) => item.id));
    }
  }, [config.addedItems, config.isEligible]);

  return (
    <div className="flex items-center gap-10 bg-putty p-10">
      {isOpened && (
        <CartGwpProducts
          gwp={gwp}
          addedItems={config.addedItems}
          onClose={() => setIsOpened(false)}
        />
      )}
      {!!gwp.giftImage && (
        <img
          className="size-45 flex-none rounded-sm"
          src={gwp.giftImage}
          alt={gwp.eligibleTitle}
        />
      )}
      <div className="flex flex-1 flex-col justify-center gap-10 pr-10">
        <div className="body-12">{config.message}</div>
        {!config.isEligible && (
          <div className="relative h-4 w-full rounded-full bg-white">
            <div
              className="absolute left-0 top-0 h-full rounded-full bg-primary"
              style={{ width: `${config.percentage}%` }}
            />
          </div>
        )}
      </div>
      {config.isEligible && config.isAdded && (
        <div className="flex size-30 flex-none items-center justify-center rounded-full bg-primary text-white">
          <CheckmarkIcon />
        </div>
      )}
      {config.isEligible && !config.isAdded && (
        <button
          onClick={() => setIsOpened(!isOpened)}
          className="cta-blue h-28 min-w-0 flex-none rounded-sm py-9"
        >
          {window.TMW.Strings.cart.add}
        </button>
      )}
    </div>
  );
};

export default withCartContext(CartGwpThreshold);
